import FindInPageIcon from "@mui/icons-material/FindInPage";
import IconButton from "@mui/material/IconButton";
import React from "react";
// external library
import CircularProgress from "@mui/material/CircularProgress";
import { PhotoSlider } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

export function ImageButton(props) {
  const images = props.value ? props.value : [];
  const [visible, setVisible] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  return (
    <React.Fragment>
      <IconButton
        onClick={() => setVisible(true)}
        disabled={images.length === 0 ? true : false}
      >
        <FindInPageIcon fontSize="inherit" />
      </IconButton>
      <PhotoSlider
        loadingElement={<CircularProgress size="3rem" color="inherit" />}
        maskOpacity={0.5}
        images={images}
        visible={visible}
        onClose={() => setVisible(false)}
        index={index}
        onIndexChange={setIndex}
      />
    </React.Fragment>
  );
}
